export default __webpack_public_path__ + "static/media/weightlossregime_2@2x.072ab5df.jpg";